import StudentExamAPI from '@/apis/business/teacher/student-exam.js'
import TeacherExamPeriodAPI from '@/apis/business/teacher/teacher-exam-period-api.js'
import SchoolExamPeriodDetailAPI from '@/apis/business/teacher/school-exam-period-detail-api.js'
import enumeration from '@/common/enumeration'

export default {
  namespaced: true,

  state: {
    studentExam: {}, // Bài làm của học sinh
    studentList: [], // Danh sách học sinh đã nộp bài
    questionDetail: {}, // Chi tiết câu hỏi đang sửa điểm
    isChange: false, // Kiểm tra dữ liệu thay đổi
    allStudentList: [], // Danh sách học sinh tham gia kỳ thi
    classRoom: {}
  },

  getters: {},

  mutations: {
    // Cập nhật bài làm kiểm tra của học sinh
    setStudentExam (state, studentExam) {
      state.studentExam = studentExam

      // Gắn lại tổng điểm bằng 0 nếu điểm của học sinh null
      state.studentExam.SubmitDetail.TotalPoint =
        state.studentExam.SubmitDetail?.TotalPoint || 0
      state.studentExam.SubmitDetail.EssayPoint =
        state.studentExam.SubmitDetail?.EssayPoint || 0
      state.studentExam.SubmitDetail.ChoicePoint =
        state.studentExam.SubmitDetail?.ChoicePoint || 0
      // Cập nhật lại trạng thái dữ liệu thay đổi
      state.isChange = false
    },

    // Cập nhật danh sách học sinh đã nộp bài
    setStudentList (state, studentList) {
      state.studentList = studentList.filter((e) => {
        return e.Status === enumeration.ExamState.Submitted
      })
    },

    // Cập nhật danh sách học sinh
    setAllStudentList (state, allStudentList) {
      state.allStudentList = allStudentList.filter((e) => {
        return !!e.JoinDate
      })
    },

    // Cập nhật trạng thái dữ liệu thay đổi
    updateIsChange (state, isChange) {
      state.isChange = isChange
    },

    // Cập nhật trạng thái Chấm/Chưa chấm của bài làm học sinh
    updateStudentExamMarkStatus (state, studentExamParams) {
      state.studentList.forEach((element) => {
        if (element.Id === studentExamParams.Id) {
          element.SubmitDetail.IsMark = studentExamParams.Status
          state.studentExam.SubmitDetail.IsMark = studentExamParams.Status
        }
      })
    },

    // Cập nhật câu hỏi đang focus để sửa điểm
    setQuestionDetail (state, questionDetail) {
      state.questionDetail = questionDetail
    },

    // Cập nhật điểm của một câu
    updateMarkOnStudentExam (state, question) {
      let choicePoint = 0
      let essayPoint = 0
      state.studentExam.SubmitDetail.Questions.forEach((element) => {
        // Cập nhật lại điểm/nhận xét ứng với câu hỏi truyền vào
        if (element.SortOrder === question.SortOrder) {
          // Cập nhật điểm cho câu
          element.Point = question.Point || 0 // Case trường hợp người dùng xóa hẳn điểm
          // Nếu là câu tự luận thì cập nhật thêm nhận xét
          if (question.Comment != null || question.Comment !== undefined) {
            element.Comment = question.Comment
          }
        }
        // Tính toán lại điểm
        if (element.Type === enumeration.QuestionType.Essay) {
          essayPoint += parseFloat(element.Point) || 0
        } else {
          choicePoint += parseFloat(element.Point) || 0
        }
      })
      // Gán lại các trường điểm
      state.studentExam.SubmitDetail.ChoicePoint = parseFloat(
        choicePoint.toFixed(2)
      )
      // Nếu có giá trị hoặc điểm bằng không
      // Case cho trường hợp đề không có câu hỏi tự luận (EssayPoint = null)
      if (state.studentExam.SubmitDetail?.EssayPoint || state.studentExam.SubmitDetail?.EssayPoint === 0) {
        state.studentExam.SubmitDetail.EssayPoint = parseFloat(
          essayPoint.toFixed(2)
        )
      }
      // Gắn lại tổng điểm bằng 0 nếu điểm của học sinh null
      state.studentExam.SubmitDetail.TotalBasePoint = parseFloat(
        (choicePoint + essayPoint).toFixed(2)
      )
      // Cập nhật lại trạng thái dữ liệu thay đổi
      state.isChange = true
    },

    // Cập nhật lại nhận xét toàn bài
    updateCommentStudentExam (state, comment) {
      state.studentExam.SubmitDetail.Comment = comment
      // Cập nhật lại trạng thái dữ liệu thay đổi
      state.isChange = true
    },

    // thông tin lớp hiện tại
    setClassRoom (state, classRoom) {
      state.classRoom = classRoom
    }
  },

  actions: {
    /**
     * @description Lấy chi tiết bài làm của học sinh
     * @param {*} context
     * @param {*} studentExamId
     * @returns
     * @author PBac
     */
    getStudentExamById (context, params) {
      return new Promise((resolve, reject) => {
        StudentExamAPI.getAsync('preview', { params })
          .then((res) => {
            if (res.Data) {
              context.commit('setStudentExam', res.Data)
              context.commit('setClassRoom', res.Data.Classroom)
            }
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description Lấy danh sách học sinh đã nộp bài
     * @param {*} context
     * @param {*} params
     * @returns
     * @author PBac
     */
    getStudentListByExamPeriodId (context, params) {
      return new Promise((resolve, reject) => {
        TeacherExamPeriodAPI.getAsync('student-detail', { params: params })
          .then((res) => {
            if (res.Data) {
              context.commit('setStudentList', res.Data)
              context.commit('setAllStudentList', res.Data)
            }
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description Lấy danh sách học sinh đã nộp bài theo id và classId
     * @param {*} context
     * @param {*} params
     * @returns
     */
    getStudentListByExamPeriodAndClassId (context, params) {
      return new Promise((resolve, reject) => {
        SchoolExamPeriodDetailAPI.getAsync('student-detail', { params: params })
          .then((res) => {
            context.commit('setStudentList', res?.Data)
            context.commit('setAllStudentList', res.Data)
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description Cập nhật bài làm của học sinh
     * @param {*} context
     * @param {*} params
     * @returns
     * @author PBac
     */
    updateStudentExamById (context, params) {
      return new Promise((resolve, reject) => {
        StudentExamAPI.putAsync('update-point', params)
          .then((res) => {
            // Cập nhật lại isChange
            context.commit('updateIsChange', false)
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description Cập nhật bài làm của học sinh
     * @param {*} context
     * @param {*} params
     * @returns
     * @author lhlong
     */
    async resetStudentExam (context, params) {
      var res = await StudentExamAPI.putAsync('/reset', params)

      return res
    },

    /**
     * @description Cập nhật bài làm của học sinh
     * @param {*} context
     * @param {*} params
     * @returns
     * @author lhlong
     */
    async updateStudentExamStatus (context, params) {
      var res = await StudentExamAPI.putAsync('/update-status', params)

      return res
    }
  }
}
